import store from '../../store'

export default async (to, from, next) => {
	if (!store.getters['auth/isAuthenticated']) {
		store.dispatch('app/setInitRoute', to.fullPath)
		return next('/auth')
	}
	return next({ meta: { layout: 'auth' } })
}
